import React from "react";
import { useNavigate } from "react-router-dom";
import "./GraduatesRoadmap.css";

export default function GraduatesRoadmap() {
  const navigate = useNavigate();

  const graduateRoadmap = [
    {
      topic: "Linux",
      percentage: 5,
      startDay: 1,
      endDay: 6,
      totalDays: 6,
      focus:
        "Terminal basics, file system, commands, permissions, process basics, and developer workflow.",
      checkpoints: [
        "Linux command assignment",
        "Terminal practice task",
        "Basic environment setup review",
      ],
    },
    {
      topic: "HTML",
      percentage: 6,
      startDay: 7,
      endDay: 18,
      totalDays: 12,
      focus:
        "HTML structure, semantic tags, forms, tables, media, SEO basics, and page structure.",
      checkpoints: ["HTML page assignment", "Resume webpage mini project", "Structure review"],
    },
    {
      topic: "CSS",
      percentage: 6,
      startDay: 19,
      endDay: 30,
      totalDays: 12,
      focus:
        "Selectors, box model, flexbox, grid, responsive design, animations, and modern UI styling.",
      checkpoints: ["Landing page assignment", "Responsive layout project", "UI review session"],
    },
    {
      topic: "Python",
      percentage: 11,
      startDay: 31,
      endDay: 57,
      totalDays: 27,
      focus:
        "Python fundamentals, functions, OOP, files, error handling, modules, scripting, and problem solving.",
      checkpoints: ["Python practice assignments", "Automation mini project", "Coding mock discussion"],
    },
    {
      topic: "FastAPI",
      percentage: 5,
      startDay: 58,
      endDay: 69,
      totalDays: 12,
      focus:
        "API creation, routing, request/response models, validation, authentication basics, and backend structure.",
      checkpoints: ["FastAPI assignment", "CRUD API mini project", "API testing review"],
    },
    {
      topic: "JavaScript",
      percentage: 5,
      startDay: 70,
      endDay: 81,
      totalDays: 12,
      focus:
        "Variables, functions, DOM, events, async JavaScript, fetch API, and browser logic.",
      checkpoints: ["JavaScript assignment", "DOM mini project", "Frontend logic review"],
    },
    {
      topic: "React.js",
      percentage: 9,
      startDay: 82,
      endDay: 101,
      totalDays: 20,
      focus:
        "Components, props, state, hooks, routing, API integration, forms, and frontend project building.",
      checkpoints: ["React assignment", "Frontend project", "Mock project explanation"],
    },
    {
      topic: "MongoDB",
      percentage: 5,
      startDay: 102,
      endDay: 108,
      totalDays: 7,
      focus:
        "Collections, documents, CRUD, schema design basics, aggregation basics, and backend integration.",
      checkpoints: ["MongoDB CRUD assignment", "Database integration task", "Data model review"],
    },
    {
      topic: "Docker",
      percentage: 6,
      startDay: 109,
      endDay: 122,
      totalDays: 14,
      focus:
        "Containers, images, Dockerfile, volumes, networks, compose basics, and deployment mindset.",
      checkpoints: ["Docker assignment", "Containerize project", "Deployment review"],
    },
    {
      topic: "Kubernetes",
      percentage: 6,
      startDay: 123,
      endDay: 136,
      totalDays: 14,
      focus:
        "Pods, deployments, services, scaling basics, config, and production system understanding.",
      checkpoints: ["Kubernetes basics task", "Deployment YAML practice", "Infra mock discussion"],
    },
    {
      topic: "GitHub",
      percentage: 5,
      startDay: 137,
      endDay: 143,
      totalDays: 7,
      focus:
        "Repositories, pull requests, README writing, project hosting, and portfolio presentation.",
      checkpoints: ["GitHub portfolio setup", "README review", "Profile improvement"],
    },
    {
      topic: "Artificial Intelligence",
      percentage: 16,
      startDay: 144,
      endDay: 180,
      totalDays: 37,
      focus:
        "AI fundamentals, machine learning, deep learning, GenAI, LLMs, NLP, computer vision, model usage, and AI project building.",
      checkpoints: [
        "AI assignment",
        "ML/AI mini project",
        "GenAI project",
        "AI project presentation",
        "Technical mock interview",
      ],
    }
  ];

  const dailyRoutine = [
    { time: "7:00 AM – 7:30 AM", task: "Morning Routine + Daily Planning", icon: "🌅", type: "Life Balance" },
    { time: "7:30 AM – 9:30 AM", task: "Guided Lecture Session", icon: "🎓", type: "Preparation" },
    { time: "9:30 AM – 10:00 AM", task: "Breakfast + Refresh", icon: "☕", type: "Life Balance" },
    { time: "10:00 AM – 11:00 AM", task: "Notes Building + Concept Revision", icon: "📝", type: "Preparation" },
    { time: "11:00 AM – 12:30 PM", task: "Coding Practice", icon: "💻", type: "Preparation" },
    { time: "12:30 PM – 1:30 PM", task: "Lunch + Rest", icon: "🍱", type: "Life Balance" },
    { time: "1:30 PM – 3:00 PM", task: "Guided Lecture / Assignment Work", icon: "🎓", type: "Preparation" },
    { time: "3:00 PM – 3:30 PM", task: "Break / Walk / Refresh", icon: "☕", type: "Life Balance" },
    { time: "3:30 PM – 5:00 PM", task: "Project Building / Coding Practice", icon: "🚀", type: "Preparation" },
    { time: "5:00 PM – 6:00 PM", task: "Doubt Solving / Revision / Peer Discussion", icon: "🔁", type: "Preparation" },
    { time: "6:00 PM – 8:00 PM", task: "Family Time + Dinner + Personal Break", icon: "🏡", type: "Life Balance" },
    { time: "8:00 PM – 9:00 PM", task: "Light Revision + Next-Day Planning", icon: "📌", type: "Preparation" },
    { time: "9:30 PM", task: "Sleep Routine", icon: "🌙", type: "Life Balance" },
  ];

  const everyTopicIncludes = [
    "Guided lecture learning and study flow",
    "Notes building and daily revision",
    "Assignments after topic completion",
    "Doubt solving and discussion rounds",
    "Mini projects and implementation tasks",
    "Saturday review and progress tracking",
    "Mock explanation or interview practice",
    "GitHub / portfolio update wherever applicable",
  ];

  // const jobSprint = [
  //   {
  //     title: "Career Positioning",
  //     items: [
  //       "Identify suitable roles based on student skills",
  //       "Choose target direction: AI, Full Stack, Data, Backend, or GenAI",
  //       "Create a strong career summary for recruiters",
  //       "Fix weak points before serious job applications",
  //     ],
  //   },
  //   {
  //     title: "Resume, LinkedIn & GitHub Upgrade",
  //     items: [
  //       "Prepare ATS-friendly resume",
  //       "Improve project-based resume content",
  //       "Polish LinkedIn headline, about section, and profile",
  //       "Clean GitHub with proper README and project links",
  //     ],
  //   },
  //   {
  //     title: "Project Explanation Confidence",
  //     items: [
  //       "Practice explaining major projects clearly",
  //       "Prepare architecture and workflow explanation",
  //       "Build answers for challenges, bugs, and improvements",
  //       "Create demo-ready project presentation flow",
  //     ],
  //   },
  //   {
  //     title: "Technical Interview Preparation",
  //     items: [
  //       "Revise core subjects based on target role",
  //       "Practice Python, JavaScript, React, backend, database, and AI questions",
  //       "Attend project-based technical mock interviews",
  //       "Correct weak areas after every mock round",
  //     ],
  //   },
  //   {
  //     title: "HR & Communication Training",
  //     items: [
  //       "Prepare strong self-introduction",
  //       "Practice salary expectation discussion",
  //       "Handle career gap and background explanation",
  //       "Prepare HR, behavioural, and final round answers",
  //     ],
  //   },
  //   {
  //     title: "Job Application Strategy",
  //     items: [
  //       "Select target companies and suitable roles",
  //       "Track daily and weekly job applications",
  //       "Prepare recruiter messages and emails",
  //       "Use LinkedIn, Naukri, company career pages, and referrals",
  //     ],
  //   },
  //   {
  //     title: "Mock Interviews & Panel Reviews",
  //     items: [
  //       "Regular mock interview practice",
  //       "Panel discussion and explanation rounds",
  //       "Resume walkthrough practice",
  //       "Feedback-based improvement plan after each session",
  //     ],
  //   },
  //   {
  //     title: "Final Push & Follow-up",
  //     items: [
  //       "Analyze interview feedback",
  //       "Plan follow-up message strategy",
  //       "Discuss offer and next steps",
  //       "Continue support until the student becomes job-ready",
  //     ],
  //   },
  // ];

  const jobSprint = [
    {
      title: "Career Positioning",
      image: "/placement/positioning.png",
      items: [
        "Identify suitable roles based on student skills",
        "Choose target direction: AI, Full Stack, Data, Backend, or GenAI",
        "Create a strong career summary for recruiters",
        "Fix weak points before serious job applications",
      ],
    },
    {
      title: "Resume, LinkedIn & GitHub Upgrade",
      image: "/placement/resume-linkedin.png",
      items: [
        "Prepare ATS-friendly resume",
        "Improve project-based resume content",
        "Polish LinkedIn headline, about section, and profile",
        "Clean GitHub with proper README and project links",
      ],
    },
    {
      title: "Project Explanation Confidence",
      image: "/placement/project-demo.png",
      items: [
        "Practice explaining major projects clearly",
        "Prepare architecture and workflow explanation",
        "Build answers for challenges, bugs, and improvements",
        "Create demo-ready project presentation flow",
      ],
    },
    {
      title: "Technical Interview Preparation",
      image: "/placement/technical-interview.png",
      items: [
        "Revise core subjects based on target role",
        "Practice Python, JavaScript, React, backend, database, and AI questions",
        "Attend project-based technical mock interviews",
        "Correct weak areas after every mock round",
      ],
    },
    {
      title: "HR & Communication Training",
      image: "/placement/hr-communication.png",
      items: [
        "Prepare strong self-introduction",
        "Practice salary expectation discussion",
        "Handle career gap and background explanation",
        "Prepare HR, behavioural, and final round answers",
      ],
    },
    {
      title: "Job Application Strategy",
      image: "/placement/job-application.png",
      items: [
        "Select target companies and suitable roles",
        "Track daily and weekly job applications",
        "Prepare recruiter messages and emails",
        "Use LinkedIn, Naukri, company career pages, and referrals",
      ],
    },
    {
      title: "Mock Interviews & Panel Reviews",
      image: "/placement/mock-interview.png",
      items: [
        "Regular mock interview practice",
        "Panel discussion and explanation rounds",
        "Resume walkthrough practice",
        "Feedback-based improvement plan after each session",
      ],
    },
    {
      title: "Final Push & Follow-up",
      image: "/placement/final-push.png",
      items: [
        "Analyze interview feedback",
        "Plan follow-up message strategy",
        "Discuss offer and next steps",
        "Continue support until the student becomes job-ready",
      ],
    },
  ];


  const preparationTasks = [
    {
      icon: "🎓",
      name: "Guided Lecture Session",
      text: "Structured lecture study, mentor-guided topic flow, and concept understanding.",
    },
    {
      icon: "📝",
      name: "Notes Building",
      text: "Writing important points, examples, commands, syntax, mistakes, and interview notes.",
    },
    {
      icon: "🔁",
      name: "Concept Revision",
      text: "Revising previous lectures, notes, weak areas, assignments, and important concepts.",
    },
    {
      icon: "💻",
      name: "Coding Practice",
      text: "Hands-on coding, examples, implementation, debugging, and regular practice tasks.",
    },
    {
      icon: "📌",
      name: "Assignment Work",
      text: "Completing assigned tasks, topic exercises, submissions, and improvement work.",
    },
    {
      icon: "🚀",
      name: "Project Building",
      text: "Building portfolio projects, GitHub updates, deployment work, and project explanation.",
    },
    {
      icon: "❓",
      name: "Doubt Solving",
      text: "Clearing pending doubts with mentor or team support during guidance windows.",
    },
    {
      icon: "🤝",
      name: "Peer Discussion",
      text: "Discussion with other students, explanation practice, group learning, and confidence building.",
    },
  ];

  const lifeBalanceTasks = [
    {
      icon: "🌅",
      name: "Morning Routine",
      text: "Wake up, fresh routine, light exercise, and daily planning.",
    },
    {
      icon: "☕",
      name: "Break / Refresh",
      text: "Short break, walk, rest, refresh, and mental reset.",
    },
    {
      icon: "🍱",
      name: "Meals + Rest",
      text: "Breakfast, lunch, nap, dinner, and personal recovery time.",
    },
    {
      icon: "🏡",
      name: "Family Time",
      text: "Personal life balance, family time, and evening recovery.",
    },
    {
      icon: "🌙",
      name: "Sleep Routine",
      text: "Consistent sleep to protect the 7 AM study routine and next-day energy.",
    },
  ];



  return (
    <main className="graduates-page">
      {/* HERO */}
      <section className="graduates-hero">
        <div className="graduates-hero-glow one" />
        <div className="graduates-hero-glow two" />

        <div className="graduates-hero-content">
          {/* <p className="grad-kicker">GRADUATES ROADMAP</p> */}
          <p className="section-kicker">GRADUATES ROADMAP</p>

          <h1>A 365-day career roadmap for serious graduates.</h1>

          <p>
            Study with discipline, build AI + Full Stack skills, complete projects,
            prepare for interviews, and target strong technology opportunities with
            guided support.
          </p>

          <div className="salary-band">
            <p className="section-kicker salary-kicker">Target preparation range</p>
            <strong>Up to ₹30 LPA</strong>
            <small>
              Based on skill, consistency, project quality, interview performance,
              market conditions, and role fit.
            </small>
          </div>

          <div className="graduates-hero-actions">
            <button onClick={() => navigate("/counselling?roadmap=graduates")}>
              Apply for Counselling
            </button>
            <a href="#graduate-roadmap">View 6-Month Roadmap</a>
          </div>
        </div>
      </section>

      {/* PRINCIPLE */}
      <section className="grad-section">
        <div className="grad-principle-box">
          <div>
            <p className="section-kicker">7 AM DISCIPLINE PRINCIPLE</p>
            <h2>Graduates are free for the full day. We convert that time into a career system.</h2>
            <p>
              The goal is not random learning. The goal is daily execution: start at 7 AM,
              study hard, complete assignments, revise, build projects, discuss doubts,
              prepare for interviews, and move step-by-step toward job readiness.
            </p>
          </div>

          <div className="mentor-clarity-card">
            <h3>Guided, not left alone.</h3>

            <p>
              Students do not have to figure out everything alone. B. Akshay personally
              guides them on career direction, AI industry clarity, discipline, study
              mindset, and important high-level doubts.
            </p>

            <p>
              Along with mentor guidance, the StudyAIPlacement team supports students through
              assignments, projects, mock interviews, panel discussions, resume reviews,
              LinkedIn/GitHub improvement, and placement preparation.
            </p>

            <p>
              The goal is to make every serious student feel supported, tracked, corrected,
              and guided throughout the learning journey.
            </p>
          </div>
        </div>
      </section>

      {/* DAILY TASK SYSTEM */}
      <section className="grad-section">
        <div className="daily-task-system">
          <div className="grad-heading compact">
            <p className="section-kicker">DAILY TASK SYSTEM</p>
            <h2>Every day has a clear task. Every task has a purpose.</h2>

            <p>
              Students do not study randomly. Each day is divided into focused preparation
              blocks like Guided Lecture Learning, Notes Building, Revision, Coding Practice,
              Assignment Work, Project Building, Doubt Solving, and Peer Discussion. Life
              balance blocks help students stay fresh, disciplined, and consistent.
            </p>
          </div>

          <div className="task-system-columns">
            <div className="task-system-panel">
              <h3>Preparation related tasks</h3>

              <div className="task-chip-grid">
                {preparationTasks.map((task) => (
                  <div className="task-chip-card" key={task.name}>
                    <div className="task-icon">{task.icon}</div>
                    <span>{task.name}</span>
                    <p>{task.text}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="task-system-panel life">
              <h3>Life balance related tasks</h3>

              <div className="task-chip-grid">
                {lifeBalanceTasks.map((task) => (
                  <div className="task-chip-card" key={task.name}>
                    <div className="task-icon">{task.icon}</div>
                    <span>{task.name}</span>
                    <p>{task.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DAILY ROUTINE */}
      <section className="grad-section">
        <div className="grad-heading">
          <p className="section-kicker">DAILY 8+ HOUR STUDY ROUTINE</p>
          <h2>A disciplined daily routine that still protects balance.</h2>

          <p>
            The timetable combines Guided Lecture Sessions, Notes Building, Concept
            Revision, Coding Practice, Assignment Work, Project Building, Doubt Solving,
            and Peer Discussion. Breaks, meals, family time, and early sleep are also
            included so students can stay consistent without burning out.
          </p>
        </div>

        <div className="routine-grid">
          {dailyRoutine.map((item) => (
            <div
              className={`routine-card ${item.type === "Life Balance" ? "life-routine-card" : "prep-routine-card"
                }`}
              key={item.time}
            >
              <div className="routine-card-top">
                <span>{item.time}</span>
                <small>{item.type}</small>
              </div>

              <div className="routine-task-line">
                <b>{item.icon}</b>
                <p>{item.task}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="weekend-system">
          <div>
            <strong>Saturday half-day</strong>
            <p>
              Weekly revision, assignment review, project checkpoint, panel discussion,
              mock interview, and progress tracking.
            </p>
          </div>

          <div>
            <strong>Sunday off</strong>
            <p>
              Recovery, personal balance, family time, and optional light revision only.
            </p>
          </div>
        </div>
      </section>

      {/* ROADMAP */}
      <section className="grad-section" id="graduate-roadmap">
        <div className="grad-heading">
          <p className="section-kicker">UP TO 6-MONTH SKILL ROADMAP</p>
          <h2>Every phase moves students closer to job readiness.</h2>

          <p>
            The roadmap starts with strong fundamentals and gradually moves into frontend,
            backend, databases, DevOps, mobile development, AI, Data Science, GenAI,
            projects, portfolio building, and interview preparation. Each phase is designed
            to build one practical layer of confidence, skill, and career readiness.
          </p>
        </div>

        <div className="roadmap-unlock-list">
          {graduateRoadmap.map((item, index) => (
            <div className="unlock-card" key={item.topic}>
              <div className="unlock-top">
                <span>Phase {String(index + 1).padStart(2, "0")}</span>
                <b>{item.percentage}%</b>
              </div>

              <h3>{item.topic}</h3>

              <div className="day-pill">
                Day {item.startDay} – Day {item.endDay}
                <small>{item.totalDays} days</small>
              </div>

              <p>{item.focus}</p>

              <div className="checkpoint-list">
                {item.checkpoints.map((checkpoint) => (
                  <span key={checkpoint}>{checkpoint}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* EVERY TOPIC */}
      <section className="grad-section">
        <div className="topic-system-box">
          <div className="grad-heading compact">
            <p className="section-kicker">INSIDE EVERY TOPIC</p>

            <h2>Students do not just watch lectures. They build, practice, and improve.</h2>
          </div>

          <div className="topic-system-grid">
            {everyTopicIncludes.map((item, index) => (
              <div className="topic-system-card" key={item}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>





      {/* JOB PREP */}
      <section className="grad-section placement-journey-section">
        <div className="grad-heading">
          <p className="section-kicker">AFTER THE 6-MONTH ROADMAP</p>

          <h2>From learning to interviews, students follow a complete placement journey.</h2>

          <p>
            Career support is not limited to resume writing. Students move through a
            structured placement journey covering profile positioning, resume,
            LinkedIn, GitHub, project explanation, mock interviews, HR preparation,
            recruiter strategy, feedback, and final placement readiness.
          </p>
        </div>

        <div className="placement-journey">
          {jobSprint.map((phase, index) => (
            <div className="placement-step" key={phase.title}>
              <div className="placement-step-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <div className="placement-step-content">
                <div className="placement-visual">
                  <img src={phase.image} alt={phase.title} />
                </div>

                <div className="placement-text">
                  <span>Placement Step {index + 1}</span>
                  <h3>{phase.title}</h3>

                  <ul>
                    {phase.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* OUTCOME */}
      <section className="grad-section">
        <div className="outcome-box">
          <p className="section-kicker">WHAT STUDENTS BUILD</p>

          <h2>Students finish with proof of skill, not just course completion.</h2>

          <p>
            By the end of the roadmap, serious students are expected to build visible
            career assets that can be shown during interviews, job applications, and
            recruiter discussions.
          </p>

          <div className="outcome-grid">
            <span>AI + Full Stack project portfolio</span>
            <span>GitHub profile with clean repositories</span>
            <span>Resume and LinkedIn readiness</span>
            <span>Deployed web applications</span>
            <span>Backend APIs with database integration</span>
            <span>AI / ML / GenAI project demos</span>
            <span>Project explanation confidence</span>
            <span>Interview and HR readiness</span>
            <span>Mock interview practice record</span>
            <span>Job application strategy clarity</span>
            <span>Internship or job application readiness</span>
            <span>Long-term career direction</span>
          </div>

          <button onClick={() => navigate("/counselling?roadmap=graduates")}>
            Apply for Counselling
          </button>
        </div>
      </section>
    </main>
  );
}